module.exports = "https://cdn.littlereply.com/tt/resource/coins.846c4f79b2274f195469ed893a5b02de.png";